$(document).on("turbolinks:load", () => {
    $('#booking_search').on('click',function(){
        $('.js-modal-booking').fadeIn();
        return false;
    });
    $('#booking-modal-close').on('click',function(){
        $('.js-modal-booking').fadeOut();
        return false;
    });

    $("#booking_choose_select_adult").on('click',function(){
        filter__for_adult();
    });    
})

function filter__for_adult(examination_cd){
    var $form = $('#new_search_for_adult_booking_choose_form');
    var value = $form.serialize();

    $.ajax(
        {url:"/schedule_time_tables/of_adult_is_filter_for_booking_choose",
        type: "GET",
        data: value
        }
    )
    .done(function(data){
        $(".card").remove();

        if(data["schedules"].length == 0){
            $(".card--main").append(`<div class="card">予約できる日程はありません。</div>`);
        }

        $.each(data["schedules"],function(index,value){
            var card_html = `
                        <div class="card">
                            ${value["all_capacity_is_full"] ? `<div class="booking-fully-occupied"><span class="entry-state error">満員</span></div>`: ``}
                            <div class="booking-inbox">
                                <div class="booking-row-block">
                                    <dl class="booking-info--row">
                                        <dt>日時</dt>
                                        <dd>
                                            <div class="is-inlineblock">
                                                <p>${value["enforce_date"]}</p>
                                                <p>${value["enforce_time"]}</p>
                                            </div>
                                        </dd>
                                    </dl>
                                    <dl class="booking-info--row">
                                        <dt>会場</dt>
                                        <dd>${value["place"]}</dd>
                                    </dl>
                                </div>
                                <ul class="booking-status">`

            var card_html2 = ``
            value["examinations_view_model"].forEach(function(ex, i){
                                    if(ex["booking_flg"]){
                                        card_html2 = card_html2 + `<li class="status-ok"> ${ex["name"]} </li>`
                                    }
                                    else{
                                        card_html2 = card_html2 + `<li class="status-ng"> ${ex["name"]} </li>`
                                    }
                                })

            var card_html3 =    `</ul>
                                        ${value["all_capacity_is_full"] ? ``:`<a href="/adult_booking_informations/new?schedule_no=${value["schedule_no"]}/"><div class="button button-lg">選択する</div></a>`}                                        
                                    </div>
                                </div>
                                    `
            $(".card--main").append(card_html + card_html2 + card_html3);

        });
            $(".booking_search_entry").children().remove();
            var search_params = data["params"]
            var search_card_html = `<div class="booking_search_card">
                                        <div class="booking-inbox">
                                                ${search_params["month"] == undefined ? `` : `<dl class="booking-info--row">
                                                                                            <dt>実施月</dt>
                                                                                            <dd>
                                                                                                <div class="is-inlineblock">
                                                                                                    <p>${search_params["month"]}</p>
                                                                                                </div>
                                                                                            </dd>
                                                                                        </dl>`}
                                                
                                                ${search_params["place"] == undefined ? `` : `<dl class="booking-info--row">
                                                                                            <dt>会場</dt>
                                                                                            <dd>${search_params["place"]}</dd>
                                                                                        </dl>`}
                                                
                                                ${Object.keys(search_params["examinations"]).length == 0 ? `` : `<dl class="booking-info--row">
                                                                                                        <dt>受診したい検診</dt>
                                                                                                        <dd>${Object.keys(search_params["examinations"]).join(',')}</dd>
                                                                                                    </dl>`}

                                                <dl class="booking-info--row">
                                                    <dt>検索方法</dt>
                                                    ${search_params["is_same_day"] == undefined ? `<dd>別日実施可</dd>`:`<dd>同日実施のみ</dd>`}
                                                </dl>
                                        </div>
                                    </div>`

            $(".booking_search_entry").append(search_card_html);

        $('.js-modal-booking').fadeOut();

    });
}


